export const hasValidAreaCode = (phoneNumberInput = ''): boolean => {
  if (!phoneNumberInput) {
    return true;
  }

  const phoneNumber = phoneNumberInput.replace(/[^\d]/g, '');
  const codeAreaPattern = /^[2-9]\d{0}/;
  return codeAreaPattern.test(phoneNumber);
};

export const formatPhoneNumber = (value: string = ''): string => {
  const valueLength = value.length;
  if (valueLength >= 10) {
    return value.slice(0, 10).replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
  }
  if (valueLength > 6) {
    return value.replace(/(\d{3})(\d{3})?(\d{1,3})?/, '($1) $2-$3');
  }
  if (valueLength > 3) {
    return value.replace(/(\d{3})(\d{1,3})/, '($1) $2');
  }
  return value;
};
